/*
 * Created on 22.02.2017
 *
 * Copyright(c) 1995 - 2017 T-Systems Multimedia Solutions GmbH
 * Riesaer Str. 5, 01129 Dresden
 * All rights reserved.
 */
import { Component } from '@angular/core';

/**
 * Diese Komponente ist eine Wrapper-Komponente welche die einzelnen Buttons beinhaltet.
 *
 * Usage:
 * <common-form-buttons>
 *  <common-form-button (clickEvt)="cancel()" value="ABBRECHEN" [btnDisabled]="dirty" [isPrimary]="true"></common-form-button>
 *  <common-form-button-element [btnValue]="btnTxt" (clickEvt)="update()" [isPrimary]="true"="styleClass"></common-form-button-element>
 ...
 * </common-form-buttons>
 *
 * @author Thomas Hamm (thm@mms-dresden.de)
 */
@Component({
    selector: 'common-form-buttons',
    template: `
        <div class="form-group">
            <div class="text-right btnWrapper">
                <ng-content></ng-content>
            </div>
        </div>
    `
})
export class ButtonsComponent {
}
